import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MAX_INVOICE_MB = 15;
export const MAX_INVOICE_BYTES = MAX_INVOICE_MB * 1024 * 1024;
export const ACCEPTED_INVOICE_EXTENSIONS = ["pdf", "jpg", "jpeg", "png"];
export const INVOICE_ACCEPT_ATTR =
  ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png";

/** Returns an error message for an unusable file, or null when it is fine. */
export const validateInvoiceFile = (file) => {
  if (!file) return "No file selected";
  const ext = file.name.split(".").pop()?.toLowerCase();
  if (!ACCEPTED_INVOICE_EXTENSIONS.includes(ext)) {
    return "Unsupported file type. Please upload a PDF, JPG or PNG file.";
  }
  if (file.size > MAX_INVOICE_BYTES) {
    return `File too large (max ${MAX_INVOICE_MB} MB)`;
  }
  return null;
};

export const formatInvoiceSize = (bytes) => {
  if (!bytes) return "0 KB";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatInvoiceDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
};

export const listComponentInvoices = (componentId) =>
  axios
    .get(`${API}/components/${componentId}/invoices`)
    .then((response) => response.data || []);

export const fetchInvoiceCounts = () =>
  axios.get(`${API}/invoices/counts`).then((response) => response.data || {});

export const uploadInvoice = (
  componentId,
  file,
  notes = "",
  onUploadProgress
) => {
  const body = new FormData();
  body.append("file", file);
  body.append("notes", notes);
  return axios.post(`${API}/components/${componentId}/invoices`, body, {
    onUploadProgress,
  });
};

export const deleteInvoice = (invoiceId) =>
  axios.delete(`${API}/invoices/${invoiceId}`);

export const updateInvoiceNotes = (invoiceId, notes) =>
  axios.patch(`${API}/invoices/${invoiceId}`, { notes });

export const fetchInvoiceBlob = (invoiceId, { download = false } = {}) =>
  axios.get(`${API}/invoices/${invoiceId}/file`, {
    responseType: "blob",
    params: download ? { download: true } : {},
  });
